module.exports = __webpack_public_path__ + "img/img3.686d0bd7.jpg";